export default __webpack_public_path__ + "static/media/l22-grey.f524a092.svg";